import styled from '@emotion/styled';
import React from 'react';
import { ZoomLevel, ZOOM_LEVELS } from './zoom';
import { timelineColors, timelineFontWeight } from './tokens';

const Button = styled('button')`
  height: 28px;
  padding: 0 12px;
  border-radius: 6px;
  border: 1px solid ${timelineColors.lineSubtle};
  background: ${timelineColors.surface};
  cursor: pointer;
  font-size: 12px;
  font-weight: ${timelineFontWeight.regular};
  color: ${timelineColors.ink};
  font-family: inherit;
`;

const IconButton = styled(Button)`
  width: 28px;
  padding: 0;
  font-size: 18px;
  line-height: 1;
`;

const Row = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

export const Controls = ({
  zoom,
  onZoomIn,
  onZoomOut,
  showCollapseAll,
  allCollapsed,
  onToggleCollapseAll,
  showHideLabels,
  hideLabels,
  onToggleHideLabels
}: {
  zoom: ZoomLevel;
  onZoomIn: () => void;
  onZoomOut: () => void;
  showCollapseAll: boolean;
  allCollapsed: boolean;
  onToggleCollapseAll: () => void;
  showHideLabels: boolean;
  hideLabels: boolean;
  onToggleHideLabels: () => void;
}) => (
  <Row>
    {showCollapseAll && (
      <Button onClick={onToggleCollapseAll}>{allCollapsed ? 'Expand all' : 'Collapse all'}</Button>
    )}
    {showHideLabels && (
      <Button onClick={onToggleHideLabels}>{hideLabels ? 'Show labels' : 'Hide labels'}</Button>
    )}
    <Row style={{ gap: 8 }}>
      <IconButton onClick={onZoomOut} disabled={zoom === 0}>
        −
      </IconButton>
      <span style={{ fontSize: 12, fontWeight: timelineFontWeight.regular, minWidth: 74, textAlign: 'center' }}>
        {ZOOM_LEVELS[zoom].label}
      </span>
      <IconButton onClick={onZoomIn} disabled={zoom === 2}>
        +
      </IconButton>
    </Row>
  </Row>
);
